import { Component, ElementRef, EventEmitter, forwardRef, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, ControlContainer, ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-hp-text-box',
  templateUrl: './hp-text-box.component.html',
  styleUrls: ['./hp-text-box.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => HpTextBoxComponent),
      multi: true
    }
  ]
})
export class HpTextBoxComponent implements OnInit, ControlValueAccessor, OnChanges {
  @Input() fieldHasValue = [];
  @Input() formControlName;
  @Input() invalidSn = ''
  _formValue = ''
  @Input() ariaLabel = false;
  @Input() options = {
    label: '',
    isRequired: '',
    placeHolder: '',
    errorMessages: {
      required: '',
      pattern: '',
      minLength: '',
      maxLength: ''
    },
    ariaLabel : ''
  }
  selectedElement = null;
  @Input() hasRequiredError = false;
  @Input() hasPatternError = false;
  @Input() hasMinLengthError = false;
  @Input() hasMaxLengthError = false;
  hasError = false;
  @Input() disabled = false;
  @Input() hasSearch = false;
  @Output() emitQuery = new EventEmitter();
  @Output() clearQuery = new EventEmitter();
  @Input() readonly = false;
  @Input()isText=true;
  @Input()urlInput=false;
  control:AbstractControl;
  @Input() removeMarginBottom = false;
  @Input() tableFilterClass = false
  @Input() tabindex = 0
  constructor(private translate: TranslateService,
              private controlContainer: ControlContainer) { }

  ngOnChanges(changes: SimpleChanges): void {
    for(let prop in changes) {
      if(prop == 'options') {
        this.selectedElement = null;
      }
    }
    // update the error input here if new input is passing
    this.hasError = (this.hasRequiredError || this.hasPatternError || this.hasMinLengthError || this.hasMaxLengthError) ? true : false;

  }

  ngOnInit(): void {
    if(this.controlContainer && this.formControlName){
      this.control = this.controlContainer.control.get(this.formControlName);
   }
  }

  get formValue() {
    return this._formValue;
  }

  set formValue(value) {
    this._formValue = value;
    this.propagateChange(this._formValue);
    this.emitQuery.emit(this._formValue);
  }

  writeValue(value) {
    if (value !== undefined) {
      this.formValue = value;
    }
  }

  propagateChange = (_: any) => { };
  propagateTouched = (_: any) => { };

  registerOnChange(fn) {
    this.propagateChange = fn;
  }

  registerOnTouched(fn) {
    this.propagateTouched = fn;
  }

  touched($event) {
    this.propagateTouched($event);
  }


  onFocus(event) {
    if(event){
       this.selectedElement = event.target;
    } else {
       this.selectedElement = null;
    }
  }
  getLabel(options) {
    if(options.placeHolder != ' ' ) {
      return this.translate.instant(this.options.placeHolder) 
    } else {
      return this.options.ariaLabel ? this.translate.instant(this.options.ariaLabel) : ''
    }
  }
  get errorMessage() {
    if(this.hasRequiredError) {
      return this.options?.errorMessages.required;
    } else if(this.hasPatternError) {
      return this.options?.errorMessages.pattern;
    } else if(this.hasMinLengthError) {
      return this.options?.errorMessages.minLength;
    } else if(this.hasMaxLengthError) {
      return this.options?.errorMessages.maxLength;
    }
  }

  getPlaceholder(options) {
    if(options.isRequired &&  this.options.placeHolder != ' ') {
      return this.translate.instant(this.options.placeHolder) + ' *'
    } else {
      return this.translate?.instant(this.options?.placeHolder)
    }
  }

  onChange(e) {
    this._formValue = e.target.value;
    this.propagateChange(this._formValue);
    this.emitQuery.emit(this._formValue);

  }

  clearInput() {
    let e  = {target: {value: ''}}
    this.onChange(e)
    this.clearQuery.emit('');
    console.log(this.control);
  }
  onKeyDown(event){
    if(!this.isText){
      return event.keyCode !== 69
    }
  }

  preventNonNumericalInput(e) {
    if(!this.isText){
    e = e || window.event;
    var charCode = (typeof e.which == "undefined") ? e.keyCode : e.which;
    var charStr = String.fromCharCode(charCode);

    if (!charStr.match(/^[0-9]+$/))
      e.preventDefault();
    }
  }

}
